import {Component, OnDestroy, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {GetSetDataService} from '../../services/get-set-data.service';
import {environment} from '../../../environments/environment';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  imports: [
    NgIf
  ],
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit, OnDestroy {

  static classRemoveBigBar: string = 'helper-remove-big-search';

  public contactFormIframeUrl?: SafeResourceUrl;

  constructor(private getSet: GetSetDataService, private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    // Hides the big/maroon/red component.
    document.getElementsByTagName('body')[0].classList.add(ContactUsComponent.classRemoveBigBar);
    this.getSet.scrollToTop();

    this.contactFormIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.CONTACT_FORM_PAGE_URL);
  }

  ngOnDestroy() {
    document.getElementsByTagName('body')[0].classList.remove(ContactUsComponent.classRemoveBigBar);
  }

}
